import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import { getOnClickAndOnKeyPressDownEvents } from 'helpers/getOnClickAndOnKeyPressDownEvents'
import Button from 'components/common/Button/Button'
import Theme from 'components/common/Theme/Theme'
import { H2 } from 'components/common/Text/Text'
import SpecsTab from './components/SpecsTab'
import { FRONT, REAR } from './constants'

const SpecificationsSection = ({
  position,
  hasRearTire,
  positionHandler,
  rearSpecifications = {},
  rearSpecTips = [],
  ...props
}) =>
  <Fragment>
    <TabWrapper hidden={ !hasRearTire }>
      <TabItem
        link
        tabIndex="0"
        active={ position === FRONT }
        data-at-sku-front-tab
        { ...getOnClickAndOnKeyPressDownEvents(() => positionHandler(FRONT)) }>Front</TabItem>
      <Separator />
      <TabItem
        link
        tabIndex="0"
        active={ position === REAR }
        data-at-sku-rear-tab
        { ...getOnClickAndOnKeyPressDownEvents(() => positionHandler(REAR)) }>Rear</TabItem>
    </TabWrapper>
    <CustomText data-at-sku-specs headline_narrow headline>Specifications</CustomText>
    <SpecsTab hidden={ position !== FRONT } { ...props } />
    {
      hasRearTire &&
        <SpecsTab
          { ...props }
          hidden={ position !== REAR }
          specTips={ rearSpecTips }
          specifications={ rearSpecifications.specList } />
    }
  </Fragment>

export default SpecificationsSection

SpecificationsSection.propTypes = {
  hasRearTire: PropTypes.bool,
  position: PropTypes.number,
  positionHandler: PropTypes.func,
  rearSpecifications: PropTypes.shape(),
  rearSpecTips: PropTypes.arrayOf(PropTypes.shape())
}

const TabItem = styled(Button)`
  display: inline-block;
  font-size: 14px;
  cursor: pointer;
  ${props => props.active && css`
    text-decoration: underline;
  `}

  && {
    padding: 10px 0;
  }
`

const CustomText = styled(H2)`
  margin: 0 0 21px;
  padding-right: 90px;
  font-size: 20px;
`

const TabWrapper = styled.div`
  float: right;
  padding: 10px 0;
`

const Separator = styled.span`
  display: inline-block;
  height: 13px;
  margin: 0 10px;
  vertical-align: middle;
  border-right: 1px solid ${Theme.colors.light_grey};
`
